import { render, staticRenderFns } from "./clipboard-images.vue?vue&type=template&id=9d9eb99e&scoped=true&lang=pug&"
import script from "./clipboard-images.vue?vue&type=script&lang=js&"
export * from "./clipboard-images.vue?vue&type=script&lang=js&"
import style0 from "./clipboard-images.vue?vue&type=style&index=0&id=9d9eb99e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9eb99e",
  null
  
)

export default component.exports